/* Design tokens + shared scalar constants. */

export const C = {
  primary: '#0cc0df', accent: '#2dd4ed', primaryLight: '#b8edf6',
  primaryDark: '#0897b2',
  bg: '#f1fbfd', border: '#d4f1f7', white: '#ffffff',
  text: '#1c1917', textMed: '#78716c', textLight: '#a8a29e',
  success: '#16a34a', successBg: '#dcfce7',
  warning: '#d97706', warningBg: '#fef3c7',
  info: '#2563eb', infoBg: '#dbeafe',
  error: '#dc2626', errorBg: '#fee2e2',
  purple: '#7c3aed', purpleBg: '#f3e8ff',
};

/* Border-radius scale — pick from these instead of arbitrary numbers. */
export const R = {
  xs: 6,    // pills, tiny chips
  sm: 8,    // small buttons, inline pills
  md: 10,   // address pills, secondary buttons
  lg: 12,   // primary buttons, inputs
  xl: 16,   // cards
  xxl: 20,  // hero cards, modals top
  pill: 9999,
};

/* Elevation scale — neutral shadows. Use `brandCard` only on the
 * featured/CTA surface where the cyan tint is intentional. */
export const SHADOW = {
  none: 'none',
  card: '0 1px 2px rgba(28,25,23,.04), 0 4px 12px rgba(28,25,23,.05)',
  raised: '0 2px 4px rgba(28,25,23,.05), 0 12px 24px rgba(28,25,23,.07)',
  sheet: '0 -8px 24px rgba(28,25,23,.10)',
  brandCard: '0 1px 2px rgba(12,192,223,.05), 0 6px 16px rgba(12,192,223,.10)',
  bottomBar: '0 -4px 16px rgba(28,25,23,.06)',
};

// Money is i64 paise everywhere. Render to rupees only at the boundary.
export const fmt = (paise) => '₹' + (paise / 100).toLocaleString('en-IN', { maximumFractionDigits: 0 });

export const TAX = 0.05;
export const DEL_FEE = 3000;
